import type { PersistedElement } from "schemas";
import { useLiteSiteStore } from "../store";

export function setIndividualElement(element: PersistedElement): void {
  useLiteSiteStore.setState(({ individualPageElements }) => ({
    individualPageElements: { ...individualPageElements, [element.id]: element },
  }));
}
